<template>
<center>
    <div class="card card-body agatrs-card-style">
        <Header pageTitle="FAQs" class="card-container"></Header>

        <div class="row no-bottom-margin">
            <div class="col-md-3 offset-md-9">
                <label for="searchBox">Search:</label>
                <el-input id="searchBox" type="search" class="mb-3 search-input" clearable prefix-icon="el-icon-search" placeholder="Search all FAQs..." v-model="searchText" v-b-popover.hover.top="'Search results appear immediately upon typing.'"></el-input>
            </div>
        </div>
        <div v-if="faqSearchResults != null" class="row">
            <card class="card-plain" body-classes="table-full-width" role="table"
        aria-label="FAQs Table">
                <el-table header-cell-class-name="table-transparent" header-row-class-name="table-transparent" row-class-name="table-transparent" :data="faqSearchResults" aria-label="FAQs table">
                    <el-table-column min-width="100" scope="col" sortable label="Question" property="question"></el-table-column>
                    <el-table-column min-width="150" scope="col" sortable label="Answer" property="answer"></el-table-column>
                </el-table>
            </card>
        </div>

    </div>
</center>
</template>

<script>
import Header from "@/components/App/Header.vue";
import {
    Table,
    TableColumn
} from 'element-ui';
export default {
    name: "FAQs",
    components: {
        Header,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    data: function () {
        return {
            allFaqs: [],
            faqSearchResults: [],
            searchText: ""
        }
    },
    watch: {
        searchText: function () {
            this.searchFaqs()
        },
    },
    mounted() {
        this.getAllFaqs()
    },
    methods: {
        searchFaqs() {
            let ctx = this;
            ctx.faqSearchResults = []
            ctx.allFaqs.forEach(function (faq, index, array) {
                if ((faq && faq.answer) && faq.answer.toLowerCase().includes(ctx.searchText.toLowerCase()) || faq.question.toLowerCase().includes(ctx.searchText.toLowerCase())) {
                    ctx.faqSearchResults.push(faq)
                }
            })
        },
        getAllFaqs() {
            this.axios
                .get(`/api/faqs`)
                .then((response) => {
                    this.allFaqs = response.data;
                    this.faqSearchResults = response.data;
                });
        }
    }
}
</script>

<style scoped>
</style>
